var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPiloteAssistant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#edc729;}.cls-2{fill:#fff;}.cls-3{fill:#4b9cff;}.cls-4{fill:#e5802e;}.cls-5{fill:#282828;}.cls-6{fill:#eda27e;}.cls-7,.cls-8{mix-blend-mode:screen;}.cls-9{fill:#71e2da;}.cls-10{clip-path:url(#clippath);}.cls-11{fill:#07050a;}.cls-12,.cls-13{fill:none;}.cls-14{fill:#ed6b48;}.cls-15{fill:#1c1917;}.cls-8{opacity:.29;}.cls-16{fill:#cc6150;}.cls-17{fill:#231a18;}.cls-13{stroke:#fff;stroke-miterlimit:10;stroke-width:4px;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "BG",
    viewBox: "0 0 600 600"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 600,
    height: 600
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "Blue-screen",
    viewBox: "0 0 600 600"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 600,
    height: 600
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "Lines-screen",
    viewBox: "0 0 600 604"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 38.36,
    x2: 0,
    y2: 38.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 47.45,
    x2: 0,
    y2: 47.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 56.55,
    x2: 0,
    y2: 56.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 65.64,
    x2: 0,
    y2: 65.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 2,
    x2: 0,
    y2: 2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 11.09,
    x2: 0,
    y2: 11.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 20.18,
    x2: 0,
    y2: 20.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 29.27,
    x2: 0,
    y2: 29.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 74.73,
    x2: 0,
    y2: 74.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 83.82,
    x2: 0,
    y2: 83.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 92.91,
    x2: 0,
    y2: 92.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 102,
    x2: 0,
    y2: 102
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 111.92,
    x2: 0,
    y2: 111.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 121.01,
    x2: 0,
    y2: 121.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 130.1,
    x2: 0,
    y2: 130.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 139.19,
    x2: 0,
    y2: 139.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 148.28,
    x2: 0,
    y2: 148.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 157.37,
    x2: 0,
    y2: 157.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 166.46,
    x2: 0,
    y2: 166.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 175.55,
    x2: 0,
    y2: 175.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 183.82,
    x2: 0,
    y2: 183.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 192.91,
    x2: 0,
    y2: 192.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 202,
    x2: 0,
    y2: 202
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 211.09,
    x2: 0,
    y2: 211.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 220.18,
    x2: 0,
    y2: 220.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 229.27,
    x2: 0,
    y2: 229.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 238.36,
    x2: 0,
    y2: 238.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 247.45,
    x2: 0,
    y2: 247.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 256.55,
    x2: 0,
    y2: 256.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 265.64,
    x2: 0,
    y2: 265.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 274.73,
    x2: 0,
    y2: 274.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 283.82,
    x2: 0,
    y2: 283.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 292.91,
    x2: 0,
    y2: 292.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 302,
    x2: 0,
    y2: 302
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 311.09,
    x2: 0,
    y2: 311.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 320.18,
    x2: 0,
    y2: 320.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 328.45,
    x2: 0,
    y2: 328.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 337.54,
    x2: 0,
    y2: 337.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 346.63,
    x2: 0,
    y2: 346.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 355.72,
    x2: 0,
    y2: 355.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 365.64,
    x2: 0,
    y2: 365.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 374.73,
    x2: 0,
    y2: 374.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 383.82,
    x2: 0,
    y2: 383.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 392.91,
    x2: 0,
    y2: 392.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 402,
    x2: 0,
    y2: 402
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 411.09,
    x2: 0,
    y2: 411.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 420.18,
    x2: 0,
    y2: 420.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 429.27,
    x2: 0,
    y2: 429.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 438.36,
    x2: 0,
    y2: 438.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 447.45,
    x2: 0,
    y2: 447.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 456.55,
    x2: 0,
    y2: 456.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 465.64,
    x2: 0,
    y2: 465.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 473.9,
    x2: 0,
    y2: 473.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 482.99,
    x2: 0,
    y2: 482.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 492.08,
    x2: 0,
    y2: 492.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 501.17,
    x2: 0,
    y2: 501.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 510.26,
    x2: 0,
    y2: 510.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 519.36,
    x2: 0,
    y2: 519.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 528.45,
    x2: 0,
    y2: 528.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 537.54,
    x2: 0,
    y2: 537.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 547.45,
    x2: 0,
    y2: 547.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 555.72,
    x2: 0,
    y2: 555.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 564.81,
    x2: 0,
    y2: 564.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 573.9,
    x2: 0,
    y2: 573.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 583.82,
    x2: 0,
    y2: 583.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 592.91,
    x2: 0,
    y2: 592.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 600,
    y1: 602,
    x2: 0,
    y2: 602
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 22.72,
    y: 45.1,
    width: 557.52,
    height: 557.52
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    width: 600,
    height: 600,
    transform: "translate(0 2)",
    xlinkHref: "#BG"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "297.37 618.84 297.37 415.33 230.26 379.52 206.79 377.37 189.42 467.16 216.04 644.76 297.37 618.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m59.26,523.32l64.73-47.31,57.38,148.63-166.17-13.72,7.91-33.2c5.21-21.87,18.03-41.15,36.15-54.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m155.94,423.71l-47.39,27.81c-3.49,2.05-5.23,6.13-4.3,10.07l18.22,77.22,40.32,96.8,26.63-8.38-26.63-97.57-6.85-105.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m206.79,377.37l-17.77,18.41c-5.1,5.28-10.55,10.2-16.31,14.74l-16.77,13.2,3.8,140.25,29.67,63.27-19.95-104.43,37.33-145.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "173.56 506.85 234.52 529.66 237.39 627.23 189.42 627.23 169.47 522.8 173.56 506.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m206.79,377.37l-3.36,64.63,34.58,76.96c.61,1.35-1.01,2.61-2.17,1.68l-12.14-9.76c-6.84-5.5-15.59-8.02-24.31-7.02l-23.6,2.72c-1.07.12-1.94-.87-1.67-1.92l32.68-127.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m175.5,506.62l25.63-2.96c7.59-.88,15.22,1.33,21.19,6.12l13.83,11.11c2.24,1.8,2.34,5.17.21,7.1l-1.63,1.47c-.13.12-.32.15-.48.09l-58.86-22.03c-.46-.17-.38-.85.11-.91Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m173.68,245.3l15.98,115.37c1.22,8.84,8.28,15.72,17.13,16.7l30.6,3.41-24.85-165.66-32.31,17.3c-4.66,2.5-7.28,7.64-6.55,12.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m242.14,385.35l-35.79-3.99c-10.69-1.19-19.19-9.48-20.66-20.15l-15.98-115.37c-.95-6.88,2.52-13.71,8.63-16.99l37.33-19.98,26.47,176.47Zm-32.72-164l-27.29,14.61c-3.16,1.7-4.96,5.23-4.47,8.79l15.98,115.37c.97,7.02,6.56,12.48,13.6,13.26l25.41,2.83-23.23-154.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m297.37,430.09l-5.31-1.03c-8.54-1.65-16.41-5.75-22.67-11.79l-39.13-37.75c-9.19-8.87-14.65-20.92-15.26-33.68l-.24-32.23c-.04-5.94-.39-11.86-1.04-17.76l-4.22-53.17c-1.15-14.49,10.01-27,24.51-27.48l63.35-2.09v216.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m297.37,405.57l-15.3-5.33c-3.62-1.26-6.92-3.3-9.68-5.97l-6.88-6.68c-.69-.67-.22-1.84.74-1.84h31.12v19.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m278.52,362.34l18.85,1.75v13.28l-9-2.41c-2.53-1.26-5.16-3.81-7.09-6.48l-3.83-3.86c-.88-.89-.17-2.4,1.07-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m279.67,294.56l-30.17-10.55c-4.86-1.7-10.27-.31-13.71,3.53l-10.37,11.57c-.19.21.04.54.3.42l10.26-4.33c3.61-1.52,7.52-2.2,11.43-1.98l32.16,1.84c.3.02.39-.41.1-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m234.52,312.45l15.38-7.39c2.06-.99,4.32-1.51,6.61-1.51h3.1c2.29,0,4.5.86,6.2,2.41l9.03,8.26-9.72-3.94c-3.88-1.57-8.13-2-12.24-1.24l-18.36,3.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 259.18,
    cy: 312.22,
    rx: 7.35,
    ry: 7.37
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "214.01 444.8 273.48 508.83 297.37 508.83 297.37 532.2 265.18 532.2 293.88 619.7 292.83 619.7 261.98 530.52 284.16 527.08 272.34 513.4 214.52 445.86 214.01 444.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m205.9,366.22l-4.67.49c-.85.09-1.66-.7-1.91-1.85l-1.66-7.65c-.31-1.43.36-2.81,1.41-2.92l4.94-.52c.88-.09,1.72.75,1.93,1.96l1.39,7.68c.25,1.4-.41,2.7-1.43,2.81Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "295.31 618.82 295.31 415.3 362.42 379.5 385.89 377.34 403.26 467.13 376.64 644.73 295.31 618.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m533.42,523.29l-64.73-47.31-57.38,148.63,166.17-13.72-7.91-33.2c-5.21-21.87-18.03-41.15-36.15-54.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m436.74,423.68l47.39,27.81c3.49,2.05,5.23,6.13,4.3,10.07l-18.22,77.22-40.32,96.8-26.63-8.38,26.63-97.57,6.85-105.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m385.89,377.34l17.77,18.41c5.1,5.28,10.55,10.2,16.31,14.74l16.77,13.2-3.8,140.25-29.67,63.27,19.95-104.43-37.33-145.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "419.12 506.82 358.16 529.63 355.29 627.2 403.26 627.2 423.21 522.77 419.12 506.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m385.89,377.34l3.36,64.63-34.58,76.96c-.61,1.35,1.01,2.61,2.17,1.68l12.14-9.76c6.84-5.5,15.59-8.02,24.31-7.02l23.6,2.72c1.07.12,1.94-.87,1.67-1.92l-32.68-127.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m417.18,506.6l-25.63-2.96c-7.59-.88-15.22,1.33-21.19,6.12l-13.83,11.11c-2.24,1.8-2.34,5.17-.21,7.1l1.63,1.47c.13.12.32.15.48.09l58.86-22.03c.46-.17.38-.85-.11-.91Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m419,245.27l-15.98,115.37c-1.22,8.84-8.28,15.72-17.13,16.7l-30.6,3.41,24.85-165.66,32.31,17.3c4.66,2.5,7.28,7.64,6.55,12.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m377.01,208.86l37.33,19.98c6.12,3.28,9.59,10.1,8.63,16.99l-15.98,115.37c-1.48,10.67-9.98,18.96-20.66,20.15l-35.79,3.99,26.47-176.47Zm-16.98,167.32l25.41-2.83c7.03-.78,12.63-6.24,13.6-13.26l15.98-115.37c.49-3.56-1.3-7.09-4.47-8.79l-27.29-14.61-23.23,154.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m295.31,430.06l5.31-1.03c8.54-1.65,16.41-5.75,22.67-11.79l39.13-37.75c9.19-8.87,14.65-20.92,15.26-33.68l.24-32.23c.04-5.94.39-11.86,1.04-17.76l4.22-53.17c1.15-14.49-10.01-27-24.51-27.48l-63.35-2.09v216.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m295.31,405.54l15.3-5.33c3.62-1.26,6.92-3.3,9.68-5.97l6.88-6.68c.69-.67.22-1.84-.74-1.84h-31.12v19.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m314.16,362.31l-18.85,1.75v13.28l9-2.41c2.53-1.26,5.16-3.81,7.09-6.48l3.83-3.86c.88-.89.17-2.4-1.07-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m313.01,294.53l30.17-10.55c4.86-1.7,10.27-.31,13.71,3.53l10.37,11.57c.19.21-.04.54-.3.42l-10.26-4.33c-3.61-1.52-7.52-2.2-11.43-1.98l-32.16,1.84c-.3.02-.39-.41-.1-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m358.16,312.42l-15.38-7.39c-2.06-.99-4.32-1.51-6.61-1.51h-3.1c-2.29,0-4.5.86-6.2,2.41l-9.03,8.26,9.72-3.94c3.88-1.57,8.13-2,12.24-1.24l18.36,3.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 333.5,
    cy: 312.19,
    rx: 7.35,
    ry: 7.37
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "378.67 444.77 319.2 508.8 295.31 508.8 295.31 532.18 327.5 532.18 298.8 619.68 299.84 619.68 330.7 530.49 308.52 527.06 320.34 513.37 378.16 445.84 378.67 444.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m386.78,366.19l4.67.49c.85.09,1.66-.7,1.91-1.85l1.66-7.65c.31-1.43-.36-2.81-1.41-2.92l-4.94-.52c-.88-.09-1.72.75-1.93,1.96l-1.39,7.68c-.25,1.4.41,2.7,1.43,2.81Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "205.84 216.41 205.84 229.11 218.95 231.78 263.93 220.98 367.3 221.49 386.82 236.73 394.46 216.41 293 213.11 205.84 216.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m216.55,207.24l-7.29,24.08c-4.26,14.07-.56,29.35,9.66,39.89l5.56,5.73c5.7,5.88,13.53,9.19,21.7,9.19h10.56l-8.03-2.84c-7.19-2.54-12.85-8.21-15.39-15.41l-.57-1.6c-3.91-11.06-1.61-23.36,6.02-32.26l17.97-20.94-40.19-5.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m361.5,192.75l.35,13.04c-7.2,12.81-6.89,28.53.82,41.04l4.19,6.8c4.29,6.97,11.22,11.91,19.2,13.68l10.31,2.29-7.23-4.51c-6.47-4.04-10.77-10.8-11.7-18.38l-.21-1.69c-1.42-11.64,3.48-23.16,12.85-30.19l7.78-16.74-36.37-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m270.06,220.19l-9.33,20.1c-3.66,7.89-3.05,17.11,1.62,24.45l16.46,25.83-8.84-22.74c-2.95-7.59-1.24-16.21,4.38-22.09l28.04-29.35-30.81-6.35-1.52,10.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m314.23,211.62l-21.57,24.35c-5.78,6.53-7.25,15.83-3.75,23.82l3.88,8.86c5.4,12.35,17.59,20.33,31.04,20.33h13.6l-13.84-5.47c-8.85-3.5-14.17-12.6-12.89-22.04l.12-.85c1.19-8.78,6.42-16.49,14.13-20.82l50.14-28.18h-60.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m240.42,194.75l.65,30.5c.38,17.82,10.39,34.04,26.14,42.33l8.56,4.51c8.78,4.62,19.05,5.49,28.47,2.4l12.17-3.99-10.32-.24c-9.25-.22-17.9-4.61-23.54-11.95l-1.26-1.63c-8.66-11.27-10.64-26.32-5.19-39.45l12.83-30.91-48.53,8.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m298.16,209.92l-14.07,19.72c-5.52,7.74-2.27,13.6,8.64,15.55l38.39,6.83-22.59-9.7c-7.54-3.24-6.06-10.2,3.8-17.85l49.16-38.16-62.57,15.72-.77,7.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m338.25,188.72l-15.7,36.22c-4.21,9.71-2.4,20.98,4.64,28.87l7.8,8.75c10.87,12.2,27.91,16.79,43.43,11.71l15.68-5.14-18.02-1.08c-11.51-.69-21.07-9.17-23.14-20.54l-.19-1.02c-1.93-10.57,1.2-21.43,8.46-29.33l19.37-21.1-42.33-7.33Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m218.14,141.24c7.24-3.62,14.57-6.41,21.71-8.55,10.21-3.06,20.78-4.75,31.42-5.43l26.05-1.65v92.87l-60.1.39c-12.51.08-24.93,2.2-36.77,6.27l-26.8,15.26c-2.3.79-4.59-1.2-4.13-3.59l3.93-26.48c3.2-16.67,7.08-36.58,19.38-48.25l11.11-10.73c4.2-4.06,8.98-7.49,14.2-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m297.32,210.34l-59.32-2.12c-5.81-.21-9.7-6.06-7.65-11.51l8.16-21.7c2.69-6.5,8.9-10.85,15.92-11.14l42.89-1.8v48.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m297.32,195.68l-16.82-.83c-1.84-.08-3.08-2.38-2.43-4.52l2.59-8.52c.85-2.55,2.83-4.26,5.05-4.37l11.6-.71v18.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m265.33,192.18c-.35,1.57-1.75,2.69-3.36,2.69l-16.25-.03c-1.84-.08-3.08-2.38-2.43-4.52l2.59-8.52c.85-2.55,2.83-4.26,5.05-4.37l13.19-.02c2.31,0,4.03,2.14,3.52,4.4l-2.32,10.36Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m376.5,141.24c-7.24-3.62-14.57-6.41-21.71-8.55-10.21-3.06-20.78-4.75-31.42-5.43l-26.05-1.65v92.87s60.1.39,60.1.39c12.51.08,24.93,2.2,36.77,6.27l26.8,15.26c2.3.79,4.59-1.2,4.13-3.59l-3.93-26.48c-3.2-16.67-7.08-36.58-19.38-48.25l-11.11-10.73c-4.2-4.06-8.98-7.49-14.2-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m297.32,210.34l59.32-2.12c5.81-.21,9.7-6.06,7.65-11.51l-8.16-21.7c-2.69-6.5-8.9-10.85-15.92-11.14l-42.89-1.8v48.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m297.32,195.68l16.82-.83c1.84-.08,3.08-2.38,2.43-4.52l-2.59-8.52c-.85-2.55-2.83-4.26-5.05-4.37l-11.6-.71v18.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m329.31,192.18c.35,1.57,1.75,2.69,3.36,2.69l16.25-.03c1.84-.08,3.08-2.38,2.43-4.52l-2.59-8.52c-.85-2.55-2.83-4.26-5.05-4.37l-13.19-.02c-2.31,0-4.03,2.14-3.52,4.4l2.32,10.36Z"
  })))), /*#__PURE__*/React.createElement("use", {
    width: 600,
    height: 604,
    xlinkHref: "#Lines-screen"
  }), /*#__PURE__*/React.createElement("use", {
    width: 600,
    height: 600,
    transform: "translate(0 2)",
    xlinkHref: "#Blue-screen"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiloteAssistant);
export default __webpack_public_path__ + "static/media/pilote_assistant.a22416c9745ee641ef3f44008f9c6b91.svg";
export { ForwardRef as ReactComponent };